module.exports = __webpack_public_path__ + "static/media/close.6ed9ea46.svg";